import { inject, Injectable } from '@angular/core';
import type { Params } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, tap, withLatestFrom } from 'rxjs';

import { FileService, StorageIconFile } from '@evc/platform';

import { BreadcrumbActions } from '@app/store/actions';
import { getRouterParams } from '@app/store/selectors';

@Injectable()
export class BreadcrumbEffects {
  readonly #actions$ = inject(Actions);
  readonly #fileService = inject(FileService);
  readonly #store = inject(Store);

  loadBreadcrumb$: any = createEffect((): any =>
    this.#actions$.pipe(
      ofType(BreadcrumbActions.loadBreadcrumb),
      withLatestFrom(this.#store.pipe(select(getRouterParams))),
      filter(
        ([
          _action,
          params,
        ]: [
          { id?: string },
          Params,
        ]) => !!params.id,
      ),
      switchMap(
        ([
          payload,
          params,
        ]: [
          { id?: string },
          Params,
        ]) =>
          this.#fileService.getFile$(payload.id || params.id).pipe(
            map((folder: StorageIconFile) =>
              BreadcrumbActions.addParent({ folder, last: !folder.parentId }),
            ),
            catchError((error: string) => of(BreadcrumbActions.loadBreadcrumbFail({ error }))),
          ),
      ),
      tap(({ folder }: { folder: StorageIconFile }) => {
        if (folder?.parentId) {
          this.#store.dispatch(BreadcrumbActions.loadBreadcrumb({ id: folder.parentId }));
        }
      }),
      catchError((error: string) => of(BreadcrumbActions.loadBreadcrumbFail({ error }))),
    ),
  );
}
